// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: white;
  border-radius: 12px;
  min-width: 400px;
  max-width: 500px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;
  overflow: hidden;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  padding: 25px 30px 20px;
  border-top: 4px solid #2196F3;
  text-align: center;
}

.modal-icon {
  font-size: 48px;
  display: block;
  margin-bottom: 15px;
}

.modal-title {
  margin: 0;
  color: #333;
  font-size: 22px;
  font-weight: 600;
}

.modal-body {
  padding: 20px 30px;
  text-align: center;
}

.modal-message {
  color: #666;
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
  white-space: pre-line;
}

.modal-footer {
  padding: 20px 30px 25px;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.modal-btn {
  padding: 12px 30px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 100px;
}

.modal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.modal-btn:active {
  transform: translateY(0);
}

.modal-btn-confirm {
  background: #2196F3;
  color: white;
}

.modal-btn-cancel {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}

.modal-btn-cancel:hover {
  background: #e0e0e0;
}

@media (max-width: 600px) {
  .modal-content {
    min-width: 90%;
    max-width: 90%;
  }
  
  .modal-footer {
    flex-direction: column-reverse;
  }
  
  .modal-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  min-width: 400px;\n  max-width: 500px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  animation: slideUp 0.3s ease-out;\n  overflow: hidden;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.modal-header {\n  padding: 25px 30px 20px;\n  border-top: 4px solid #2196F3;\n  text-align: center;\n}\n\n.modal-icon {\n  font-size: 48px;\n  display: block;\n  margin-bottom: 15px;\n}\n\n.modal-title {\n  margin: 0;\n  color: #333;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.modal-body {\n  padding: 20px 30px;\n  text-align: center;\n}\n\n.modal-message {\n  color: #666;\n  font-size: 16px;\n  line-height: 1.6;\n  margin: 0;\n  white-space: pre-line;\n}\n\n.modal-footer {\n  padding: 20px 30px 25px;\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n}\n\n.modal-btn {\n  padding: 12px 30px;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 100px;\n}\n\n.modal-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.modal-btn:active {\n  transform: translateY(0);\n}\n\n.modal-btn-confirm {\n  background: #2196F3;\n  color: white;\n}\n\n.modal-btn-cancel {\n  background: #f5f5f5;\n  color: #666;\n  border: 1px solid #ddd;\n}\n\n.modal-btn-cancel:hover {\n  background: #e0e0e0;\n}\n\n@media (max-width: 600px) {\n  .modal-content {\n    min-width: 90%;\n    max-width: 90%;\n  }\n  \n  .modal-footer {\n    flex-direction: column-reverse;\n  }\n  \n  .modal-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
